import loadable from "@loadable/component";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { tw } from "@careinfo/tailwind";
import { getKey } from "../../helpers/sessionKey";
import { useState } from "react";
import { usePDFPrintHook } from "@careinfo/layout";
import { useNavigate } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
const CreateDailyNoteComponent = loadable(
  () => import("../../components/DailyNote/CreateDailyNote")
);

const CreateDailyNote = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["daily-note"],
    navigateURL: "",
  });
  const navigate = useNavigate();
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [dailyNoteId, setDailyNoteId] = useState(false);

  const handleCreate = async (values: any, openPrintPopup, setError: any) => {
    const url = `${APIS.DAILY_NOTE}`;
    let formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        if (openPrintPopup) {
          setOpenPrintPopup(true);
          setDailyNoteId(res?.data?.id);
        } else {
          navigate("/daily-notes");
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const defaultBranch = getKey("default-branch");


  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Expense Note
        </span>
      </div>
      
        <CreateDailyNoteComponent
          handleCreate={handleCreate}
          isLoading={isPostLoading}
          defaultBranch={defaultBranch}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
        />
    </>
  );
};

export default CreateDailyNote;
